import styled from 'styled-components';

import {Stack as BaseStack} from '@edna/components/primitives';

export const Stack = styled(BaseStack)`
  flex-wrap: wrap;
`;
